"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scale = exports.rotate = exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.setHair = exports.setHead = exports.setBody = exports.create = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var angleUtil_sidecar_1 = require("@lib/angleUtil-sidecar");
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageBodiesData_1 = require("@voyage/entities/voyageBodiesData");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
var _masterScale = 0.25;
function create() {
    var body = rando_sidecar_1.rando.sample(voyageBodiesData_1.bodies);
    var head = rando_sidecar_1.rando.sample(voyageBodiesData_1.heads);
    var hair = rando_sidecar_1.rando.sample(voyageBodiesData_1.hairs);
    var imageBody = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrew, body.frames[0]);
    var _scale = _masterScale;
    var bodyColor = rando_sidecar_1.rando.sample(voyageBodiesData_1.clothesColors);
    imageBody.tint = bodyColor;
    var imageHead = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrew, head.frames[0]);
    var headColor = rando_sidecar_1.rando.sample(voyageBodiesData_1.skinTones);
    imageHead.tint = headColor;
    var imageHair = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrew, hair.frames[0] || sprites_sidecar_1.sprites.voyHairBuzz[0]);
    var hairColor = rando_sidecar_1.rando.sample(voyageBodiesData_1.hairColors);
    if (!hair.frames[0]) {
        imageHair.visible = false;
    }
    else {
        imageHair.tint = hairColor;
    }
    var id = common_1.createId();
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        imageBody: imageBody,
        imageHead: imageHead,
        imageHair: imageHair,
        x: 0,
        y: 0,
        isFlipped: false,
        body: body,
        head: head,
        hair: hair,
        scale: _scale,
        bodyColor: bodyColor,
        hairColor: hairColor,
        headColor: headColor,
        rotation: 0,
    };
    objs.push(obj);
    scale(obj, _scale);
    return obj;
}
exports.create = create;
function setBody(obj, d) {
    obj.body = d;
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageBody, obj.body.frames[0]);
    scale(obj, obj.scale);
}
exports.setBody = setBody;
function setHead(obj, d) {
    obj.head = d;
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageHead, obj.head.frames[0]);
    scale(obj, obj.scale);
}
exports.setHead = setHead;
function setHair(obj, d) {
    obj.hair = d;
    if (obj.hair.frames[0]) {
        spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageHair, obj.hair.frames[0]);
        obj.imageHair.visible = true;
    }
    else {
        obj.imageHair.visible = false;
    }
    scale(obj, obj.scale);
}
exports.setHair = setHair;
function moveToXY(obj, x, y, isFlipped) {
    obj.isFlipped = isFlipped;
    obj.x = x;
    obj.y = y;
    obj.imageBody.x = x;
    obj.imageBody.y = y;
    obj.imageBody.rotation = obj.rotation;
    var flipmult = 1;
    if (obj.isFlipped) {
        flipmult = -1;
    }
    obj.imageBody.flipX = obj.isFlipped;
    obj.imageHead.flipX = obj.isFlipped;
    obj.imageHair.flipX = obj.isFlipped;
    var sc = obj.scale;
    var x1 = 10 * sc * flipmult;
    var y1 = -70 * sc;
    obj.imageHead.x = x + mathUtils_sidecar_1.mathUtils.rotX(x1, y1, obj.rotation);
    obj.imageHead.y = y + mathUtils_sidecar_1.mathUtils.rotY(x1, y1, obj.rotation);
    obj.imageHead.rotation = obj.rotation;
    var adj = obj.hair.adj[obj.head.idx];
    var x2 = 0 * sc * flipmult + adj.ox * flipmult * sc;
    var y2 = -90 * sc + adj.oy * sc;
    obj.imageHair.x = x + mathUtils_sidecar_1.mathUtils.rotX(x2, y2, obj.rotation);
    obj.imageHair.y = y + mathUtils_sidecar_1.mathUtils.rotY(x2, y2, obj.rotation);
    obj.imageHair.rotation = obj.rotation;
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.imageBody.destroy();
        c.imageHead.destroy();
        c.imageHair.destroy();
    });
}
exports.removeDead = removeDead;
function update(obj) { }
function rotate(obj, rot) {
    if (rot === void 0) { rot = angleUtil_sidecar_1.angleUtil.turn * 0.25; }
    obj.rotation = rot;
    moveToXY(obj, obj.x, obj.y, obj.isFlipped);
}
exports.rotate = rotate;
function scale(obj, scale) {
    obj.scale = scale;
    var adj = obj.hair.adj[obj.head.idx];
    obj.imageBody.scale = 1 * scale;
    obj.imageHead.scale = 0.75 * scale;
    obj.imageHair.scaleX = 0.75 * scale * adj.sx;
    obj.imageHair.scaleY = 0.75 * scale * adj.sy;
    moveToXY(obj, obj.x, obj.y, obj.isFlipped);
}
exports.scale = scale;
